import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { exportTeamShiftAssignment, importTeamShiftAssignment, getTeamShiftAssignmentList, getTeamShiftAssignmentListById, addTeamShiftAssignment, updateTeamShiftAssignment, deleteTeamShiftAssignment } from '../../helpers/';
import { teamShiftAssignmentApiResponseSuccess, teamShiftAssignmentApiResponseError } from './actions';
import { TeamShiftAssignmentActionTypes } from './constans';

/**
 * 
 * Team Shift Assignment
 * @param {*} payload
 * @query
 * 
 */

function* teamShiftAssignmentExport({ payload }) {
  try {
    const response = yield call(exportTeamShiftAssignment, payload.params);
    yield put(teamShiftAssignmentApiResponseSuccess(TeamShiftAssignmentActionTypes.EXPORT_TEAM_SHIFT_ASSIGNMENT, response.data));
  } catch(error) {
    yield put(teamShiftAssignmentApiResponseError(TeamShiftAssignmentActionTypes.EXPORT_TEAM_SHIFT_ASSIGNMENT, error));
  }
};

function* teamShiftAssignmentImport({ payload }) {
  try {
    const response = yield call(importTeamShiftAssignment, payload.params);
    yield put(teamShiftAssignmentApiResponseSuccess(TeamShiftAssignmentActionTypes.IMPORT_TEAM_SHIFT_ASSIGNMENT, response.data));
  } catch(error) {
    yield put(teamShiftAssignmentApiResponseError(TeamShiftAssignmentActionTypes.IMPORT_TEAM_SHIFT_ASSIGNMENT, error))
  }
};

function* teamShiftAssignmentList({ payload }) {
  try {
    const response = yield call(getTeamShiftAssignmentList, payload.params);
    yield put(teamShiftAssignmentApiResponseSuccess(TeamShiftAssignmentActionTypes.GET_TEAM_SHIFT_ASSIGNMENT, response.data));
  } catch(error) {
    yield put(teamShiftAssignmentApiResponseError(TeamShiftAssignmentActionTypes.GET_TEAM_SHIFT_ASSIGNMENT, error));
  }
};

function* teamShiftAssignmentListById({ payload }) {
  try {
    const response = yield call(getTeamShiftAssignmentListById, payload.params);
  } catch(error) {
    yield put(teamShiftAssignmentApiResponseError(TeamShiftAssignmentActionTypes.GET_TEAM_SHIFT_ASSIGNMENT_BY_ID, error))
  }
};

function* teamShiftAssignmentAdd({ payload }) {
  try {
    const response = yield call(addTeamShiftAssignment, payload.params);
    yield put(teamShiftAssignmentApiResponseSuccess(TeamShiftAssignmentActionTypes.ADD_TEAM_SHIFT_ASSIGNMENT, response.data));
  } catch(error) {
    yield put(teamShiftAssignmentApiResponseError(TeamShiftAssignmentActionTypes.ADD_TEAM_SHIFT_ASSIGNMENT, error))
  }
};

function* teamShiftAssignmentUpdate({ payload }) {
  try {
    const response = yield call(updateTeamShiftAssignment, payload.params);
    yield put(teamShiftAssignmentApiResponseSuccess(TeamShiftAssignmentActionTypes.UPDATE_TEAM_SHIFT_ASSIGNMENT, response.data));
  } catch(error) {
    yield put(teamShiftAssignmentApiResponseError(TeamShiftAssignmentActionTypes.UPDATE_TEAM_SHIFT_ASSIGNMENT, error));
  }
};

function* teamShiftAssignmentDelete({ payload }) {
  try {
    const response = yield call(deleteTeamShiftAssignment, payload.params);
    yield put(teamShiftAssignmentApiResponseSuccess(TeamShiftAssignmentActionTypes.DELETE_TEAM_SHIFT_ASSIGNMENT, response.data));
  } catch(error) {
    yield put(teamShiftAssignmentApiResponseError(TeamShiftAssignmentActionTypes.DELETE_TEAM_SHIFT_ASSIGNMENT, error));
  }
};


export function* watchTeamShiftAssignmentExport() {
  yield takeEvery(TeamShiftAssignmentActionTypes.EXPORT_TEAM_SHIFT_ASSIGNMENT, teamShiftAssignmentExport);
};

export function* watchTeamShiftAssignmentImport() {
  yield takeEvery(TeamShiftAssignmentActionTypes.IMPORT_TEAM_SHIFT_ASSIGNMENT, teamShiftAssignmentImport)
};

export function* watchTeamShiftAssignmentList() {
  yield takeEvery(TeamShiftAssignmentActionTypes.GET_TEAM_SHIFT_ASSIGNMENT, teamShiftAssignmentList);
};

export function* watchTeamShiftAssignmentListById() {
  yield takeEvery(TeamShiftAssignmentActionTypes.GET_TEAM_SHIFT_ASSIGNMENT_BY_ID, teamShiftAssignmentListById);
};

export function* watchTeamShiftAssignmentAdd() {
  yield takeEvery(TeamShiftAssignmentActionTypes.ADD_TEAM_SHIFT_ASSIGNMENT, teamShiftAssignmentAdd);
};

export function* watchTeamShiftAssignmentUpdate() {
  yield takeEvery(TeamShiftAssignmentActionTypes.UPDATE_TEAM_SHIFT_ASSIGNMENT, teamShiftAssignmentUpdate);
};

export function* watchTeamShiftAssignmentDelete() {
  yield takeEvery(TeamShiftAssignmentActionTypes.DELETE_TEAM_SHIFT_ASSIGNMENT, teamShiftAssignmentDelete)
};

function* teamShiftAssignmentSaga() {
  yield all([
    fork(watchTeamShiftAssignmentExport),
    fork(watchTeamShiftAssignmentImport),
    fork(watchTeamShiftAssignmentList),
    fork(watchTeamShiftAssignmentListById),
    fork(watchTeamShiftAssignmentAdd),
    fork(watchTeamShiftAssignmentUpdate),
    fork(watchTeamShiftAssignmentDelete)
  ]);
}

export default teamShiftAssignmentSaga;